import React from 'react';
import { AppScreenshot } from '../../types';
import { useI18n } from '../../context/I18nContext';
import { ScreenImage } from '../ui/ScreenImage';

export interface ScreenshotGalleryProps {
  screenshots?: AppScreenshot[];
  /** Called with the clicked image index to open the enlarged view. */
  onOpen?: (index: number) => void;
}

export const ScreenshotGallery: React.FC<ScreenshotGalleryProps> = ({ screenshots, onOpen }) => {
  const { resolveText, t } = useI18n();

  if (!screenshots || screenshots.length === 0) return null;

  return (
    <ul className="flex gap-4 sm:gap-6 overflow-x-auto pb-4 snap-x snap-mandatory -mx-4 px-4 scroll-px-4 sm:mx-0 sm:px-0 sm:scroll-px-0 lg:grid lg:grid-flow-col lg:auto-cols-fr lg:overflow-visible lg:pb-0">
      {screenshots.map((s, i) => {
        const caption = s.caption ? resolveText(s.caption) : undefined;
        return (
          <li key={s.id} className="shrink-0 snap-start w-[220px] sm:w-[240px] lg:w-auto lg:max-w-[280px]">
            <figure>
              {onOpen ? (
                <button
                  type="button"
                  onClick={() => onOpen(i)}
                  className="block w-full rounded-lg cursor-zoom-in transition-shadow hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
                  aria-label={`${caption ?? resolveText(s.alt)} – ${t.appDetail.lightboxOpen}`}
                >
                  <ScreenImage imageUrl={s.url} altText={resolveText(s.alt)} />
                </button>
              ) : (
                <ScreenImage imageUrl={s.url} altText={resolveText(s.alt)} />
              )}
              {caption && (
                <figcaption className="mt-3 text-sm font-medium text-slate-700 leading-snug">
                  {caption}
                </figcaption>
              )}
            </figure>
          </li>
        );
      })}
    </ul>
  );
};
